// 20.1.2.5 Number.isSafeInteger(number)
var $export   = require('./_export')
  , isInteger = require('./_is-integer')
  , abs       = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number){
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-polyfill/~/core-js/modules/es6.number.is-safe-integer.js
 ** module id = 305
 ** module chunks = 0
 **/